import axios from 'axios';
// 生产系统首页


const timestatus = (data) => axios.get('/pro/conf/list', data);
const timeliness = (data) => axios.get('/logist/distribut/list', data);//配送及时率
const vehicletype = (data)=>axios.get('/logist/carInfo/list', data);//车辆类型
const statepersonnel = (data) => axios.get('/logist/manState/list', data);//人员状态
const logisticssafety = (data) => axios.get('/logist/safe/list', data);//物流安全


export default {
  timestatus,
  timeliness,
  vehicletype,
  statepersonnel,
  logisticssafety,
}
